<template>
	<div class="element-button is-empty">
		<a v-if="link" :href="link" :target="target" class="app--button d-block border--button"
			:class="[options('style'), classes()]">
			<span v-html="macro(options('label'))"></span>
		</a>
	</div>
</template>

<script>
import store from '../../store'

export default {
	props: {
		definition: { type: Object, required: true },
		element: { type: Object, required: true },
	},
	computed: {
		link() {
			if (this.smartlink != '') {
				return this.smartlink
			}
			let url = this.options('url') ? this.options('url') : ''
			if (this.options('type') == 'email') {
				return 'mailto:' + url
			}
			if (url == 'http://PFP::print') {
				url = '/e/media/print/' + store.state.id
				if (store.state.type == 'preview-engagement') {
					url = '#'
				}
			}
			if (url.startsWith('http://PFP::pdf:')) {
				url = '/e/media/pdf/' + store.state.id + '/' + url.replace('http://PFP::pdf:', '')
				if (store.state.type == 'preview-engagement') {
					url = '#'
				}
			}
			url = this.macro(url)
			return url
		},
		smartlink() {
			return this.options('smartlink') ? store.getters.smartlink(this.options('smartlink'), this.element, 'url') : ''
		},
		target() {
			let target = this.options('target')
			let url = this.options('url') ? this.options('url') : ''
			if (store.state.type == 'preview-engagement') {
				target = '_blank'
			}
			if (url == 'http://PFP::print') {
				target = '_blank'
				if (store.state.type == 'preview-engagement') {
					target = '_self'
				}
			}
			if (url.startsWith('http://PFP::pdf:')) {
				target = '_blank'
				if (store.state.type == 'preview-engagement') {
					target = '_self'
				}
			}
			return target
		}
	},
	methods: {
		classes() { let p = store.state.theme.print.elements.input; return 'print--size-' + p.size + ' print--color-' + p.color },
		macro(value) { return store.getters['macro'](value) },
		options(value) { return store.getters['options'](this.definition, value) },
	}
}
</script>
